import React, { useEffect } from 'react';
import {
  Modal,
  Text,
  Title,
  Spinner,
} from '@cochlear-design-system/foundation';
import { PatientRecordContext } from '../contexts/PatientRecordContext';
import { setIdpParam } from '../../../utils/authprovider';
import {
  routes,
  envUrlSRPortal,
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
} from '../../../config';
import { ScheduleSRPortal } from '../../ScheduleSRPortal';
import cookieService from '../../../services/cookieService';
import providerService from '../../../services/providerService';

export const ViewServiceRequestModal = () => {
  const {
    showViewServiceRequestModal,
    setShowViewServiceRequestModal,
    serviceRequestLoaded,
    serviceRequestUrl,
    selectedServiceRequestId,
    selectedServiceRequestIframe,
    setServiceRequestLoaded,
    patientId,
    labels,
  } = React.useContext(PatientRecordContext);

  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails();
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;
  const showSRPortal = serviceRequestUrl === '__SRPORTAL__';

  const srPortalConfig = {
    enabled: true,
    scheduleSRPortalScriptPath: `${envUrlSRPortal}/static/chunks/remoteEntry.js`,
    apiBaseUrl: envUrlSRPortal,
  };

  useEffect(() => {
    if (showSRPortal) {
      setServiceRequestLoaded(true);
    }
  }, [
    serviceRequestUrl,
    setServiceRequestLoaded,
    selectedServiceRequestId,
  ]);

  return (
    <Modal
      footer=""
      show={showViewServiceRequestModal}
      title=""
      onHide={() => setShowViewServiceRequestModal(false)}
      size="xl"
    >
      <Modal.Header closeButton data-analytics="close_view_sr_modal">
        <Modal.Title>&nbsp;</Modal.Title>
      </Modal.Header>
      <Title
        content={
          labels[
            'labels.patientRecord.tabs.serviceRequests.view.title'
          ]
        }
        size="heading-2"
        tag="h2"
        style={{
          marginLeft: '2rem',
        }}
      />

      {!serviceRequestLoaded && !showSRPortal && (
        <div
          style={{
            margin: 'auto',
            textAlign: 'center',
            marginTop: '3rem',
          }}
        >
          <>
            <Spinner animation="border" />
            <Text
              content={
                labels[
                  'labels.patientRecord.tabs.serviceRequests.view.loading'
                ]
              }
            />
          </>
        </div>
      )}
      {showSRPortal ? (
        <ScheduleSRPortal
          key={selectedServiceRequestId}
          config={srPortalConfig}
          accessToken={accessToken}
          idToken={idToken}
          selectedProviderId={providerId}
          pageType="ServiceRequestDetails"
          logoutUrl={logoutUrl}
          patientId={patientId}
          serviceRequestId={selectedServiceRequestId}
          hideInternalNavigation
        />
      ) : (
        <iframe
          src={setIdpParam(
            `${routes.mcp.domain}${serviceRequestUrl}&dpx=true`,
          )}
          title="View SR"
          width="100%"
          style={{ marginTop: '0', visibility: 'hidden' }}
          ref={selectedServiceRequestIframe}
        />
      )}
    </Modal>
  );
};
